module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fChc4AMP6lbBP.31b119db.woff2";